export const ACTION_UPDATE_DATA = 'CONTENTFUL:UPDATE_DATA'
export const ACTION_UPDATING_DATA = 'CONTENTFUL_ACTION_UPDATING_DATA'